import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FeesTableSchema, HistoryAmountTableSchema, HistoryDescriptionTableSchema } from '../../types/types';
import { getFeeDetailsThunk } from './thunks';

interface DetailsState {
    loading: boolean;
    error: boolean;
    data: FeesTableSchema[] | [];
    feeCode: string;
    feeDescription: string;
    subFee: HistoryDescriptionTableSchema[] | [];
    descriptionHistory: FeesTableSchema[] | [];
    amountHistory: HistoryAmountTableSchema[] | [];
}

const initialState: DetailsState = {
    loading: false,
    error: false,
    data: [],
    feeCode: "",
    feeDescription: "",
    subFee: [],
    descriptionHistory: [],
    amountHistory: [],
};

const detailsSlice = createSlice({
    name: 'details',
    initialState,
    reducers: {
        setData: (state: any, action: PayloadAction<FeesTableSchema>) => {
            return {
                ...state,
                data: action.payload,
            }
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getFeeDetailsThunk.pending, (state) => {
            state.loading = true;
            state.error = false;
        }).addCase(getFeeDetailsThunk.fulfilled, (state, action) => {
            state.loading = false;
            const { feeCode, feeDescription, subFee, descriptionHistory, amountHistory } = action.payload;
            state.feeCode = feeCode;
            state.feeDescription = feeDescription;
            state.subFee = subFee;
            state.descriptionHistory = descriptionHistory;
            state.amountHistory = amountHistory;
        }).addCase(getFeeDetailsThunk.rejected, (state, action) => {
            state.loading = false;
            state.error = true;
        })
    }
});

export default detailsSlice;